import useConfig from './useConfig';

export default () => {
    const config = useConfig();
    return config.mode === 'app';
};
